import sortBy from 'lodash/sortBy';

import { Entity } from '@evidentid/tprm-portal-lib/models/dashboard';
import { RiskProfile } from '@evidentid/tprm-portal-lib/models/decisioning';
import { TprmRequirementModel } from '@evidentid/tprm-portal-lib/models/entity-details';

import { CategorizedEnumLabels } from '@/modules/dashboard/models/CategorizedEnumLabels.model';
import {
    getRequirementTypeLabelByCountry,
} from '@/utils/get-requirement-type-label-by-country/getRequirementTypeLabelByCountry';

/** The country whose requirement labels apply to an entity.
 *
 * An entity can sit in several risk profiles, which may disagree on country. The first by
 * display name is picked so the label is stable across renders rather than depending on the
 * order the API happened to return.
 */
export function getEntityCountryCode(entity: Entity, riskProfiles: RiskProfile[]): string | null {
    const riskProfileId = sortBy(
        entity.effectiveGroup || [],
        [ (riskProfile) => riskProfile.displayName.toLowerCase() ],
    )[0]?.id;
    return riskProfiles.find((riskProfile) => riskProfile.id === riskProfileId)?.countryCode || null;
}

/** Requirement models carrying the label an RP's users expect for this entity's country —
 *  "Employers Liability" where the generic model says "Workers Compensation", for instance.
 *
 * TODO[PRODUCT-24130]: refactor to use TprmRequirementDefinition instead of TprmRequirementModel;
 * this requires the definition to have the schema that the coverage model contains.
 */
export function getRequirementModelsWithCountryLabel(
    entity: Entity,
    requirementModels: TprmRequirementModel[],
    riskProfiles: RiskProfile[],
    enumLabels: CategorizedEnumLabels,
): TprmRequirementModel[] {
    const countryCode = getEntityCountryCode(entity, riskProfiles);
    return requirementModels.map((model) => ({
        ...model,
        label: getRequirementTypeLabelByCountry(model.coverageType, countryCode, enumLabels),
    }));
}
